import React from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import CustomPasswordField from "../common/CustomPasswordField";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import { FormTitle } from "../common/FormBox";

const ChangePasswordForm = ({ title, formik, update }) => {
  return (
    <>
      {!update && (
        <FormTitle 
          title={" New Password"}
          subTitle={
            "Please create new password and confirm it to set a new password"
          }
        />
      )}

      <Box
        component={"form"}
        noValidate
        sx={{ mt: 4 }}
        onSubmit={formik.handleSubmit}
      >
        {update && (
          <CustomPasswordField
            id="oldPassword"
            name="user_oldpassword"
            label="Old Password"
            type="password"
            autoComplete="current-password"
            endAdornmentIcon={HttpsOutlinedIcon}
            placeholder={"Enter Your Old Password"}
            formik={formik}
          />
        )}

        <CustomPasswordField
          id="password"
          name="user_password"
          label="New Password"
          type="password"
          autoComplete="new-password"
          endAdornmentIcon={HttpsOutlinedIcon}
          placeholder={"Enter Your New Password"}
          formik={formik}
        />
        <CustomPasswordField
          id="Confirmpassword"
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          autoComplete="new-password"
          endAdornmentIcon={HttpsOutlinedIcon}
          placeholder={"Confirm Your New Password"}
          formik={formik}
        />
        <Button
          type="submit"
          fullWidth={!update}
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2, fontSize: "12px"}}
          disabled={formik.isSubmitting}
          startIcon={formik.isSubmitting && <CircularProgress size={24} />}
        >
          {formik.isSubmitting ? "Change Password..." : "Change Password"}
        </Button>
      </Box>
    </>
  );
};

export default ChangePasswordForm;
